import { BlokProps } from "@/helpers/StoryblokHelpers"
import { urlParser } from "@/lib/urlParser"
import { ArrowLinkSectionStoryblok } from "@/types/component-types"
import { SbBlokData, storyblokEditable } from "@storyblok/react/rsc"
import Link from "next/link"
import { FiChevronRight } from "react-icons/fi"

export const ArrowLinkSection = ({ blok }: BlokProps<ArrowLinkSectionStoryblok>) => {
  const { items } = blok

  return (
    <section
      {...storyblokEditable(blok as SbBlokData)}
      className="flex flex-col gap-6 bg-surface lg:gap-8 lg:pb-[18px] lg:pt-2"
    >
      <div className="mx-auto w-full max-w-[1155px] scroll-mt-32 px-4 lg:px-8">
        {items.map(item => (
          <Link
            key={item._uid}
            href={urlParser(item.link.cached_url)}
            target={item.link.target ? String(item.link.target) : "_self"}
            rel={item.link.target === "_blank" ? "noopener noreferrer" : undefined}
            className="inline-flex items-center text-sm text-neutral-50 hover:text-primary-50 lg:text-base"
          >
            {item.title}
            <FiChevronRight className="shrink-0 text-2xl" />
          </Link>
        ))}
      </div>
    </section>
  )
}
